"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvelopeResponseSchema = void 0;
var zod_1 = require("zod");
var EnvelopeResponseSchema = function (payloadSchema) {
    return zod_1.z.object({
        code: zod_1.z.string(),
        message: zod_1.z.string(),
        payload: payloadSchema,
    });
};
exports.EnvelopeResponseSchema = EnvelopeResponseSchema;
